import { ShieldBan, Smartphone } from "lucide-react";
import { DashboardLayout } from "@/components/layout/dashboard-layout";
import { MobileHeader } from "@/components/layout/mobile-header";
import { PageHeaderDesktop } from "@/components/layout/page-header-desktop";
import { Card, CardContent } from "@/components/ui/card";
import { t } from "@/lib/i18n";
import { salesChannelsSidebar } from "@/config/navigation";

/**
 * Mobile app management is intentionally unavailable for the launch cohort.
 * The layout replaces every nested route, preventing publish/config actions
 * from mounting when a merchant opens an old bookmark directly.
 */
export default function MobileAppLayout({ children }: { children: React.ReactNode }) {
  void children;
  return (
    <DashboardLayout sidebarSections={salesChannelsSidebar}>
      <div className="lg:hidden">
        <MobileHeader
          title={t("mobileApp.title")}
          showBackButton
          backHref="/sales-channels"
        />
      </div>

      <div className="hidden lg:block">
        <PageHeaderDesktop
          variant="form"
          title={t("mobileApp.title")}
          backHref="/sales-channels"
        />
      </div>

      <div className="px-4 lg:px-0 pt-4 lg:pt-0">
        <Card className="border-dashed">
          <CardContent className="p-8 text-center">
            <div className="relative mx-auto mb-4 flex size-16 items-center justify-center rounded-2xl bg-muted">
              <Smartphone className="size-8 text-muted-foreground" />
              <ShieldBan className="absolute -bottom-1 -end-1 size-6 rounded-full bg-background text-muted-foreground" />
            </div>
            <h2 className="text-lg font-semibold">
              {t("salesChannels.unavailableTitle")}
            </h2>
            <p className="mt-2 text-sm text-muted-foreground">
              {t("salesChannels.unavailableDescription")}
            </p>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
